<template>
  <info-screen
    :title="t('plans.forbidden-title')"
    :message="t('plans.forbidden-text')"
    :image="DeviceError"
    :confirm-text="t('ctas.back')"
    @confirm="logout"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import DeviceError from '@/assets/device-error.svg'
import InfoScreen from '@/components/InfoScreen.vue'
import { useAuthStore } from '@/store/auth'

const authStore = useAuthStore()
const { t } = useI18n()

function logout() {
  authStore.logout()
}
</script>
